/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Max Lines Per Event" |
*
* @param {Plain_Text_Import_Max_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_lines_label = /** @type {((inputs?: Plain_Text_Import_Max_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre max de lignes par evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeilen pro Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di linee per evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество линий на мероприятие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de líneas por evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每场比赛最多行数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントあたりの最大行数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति इवेंट अधिकतम लाइनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de linhas por evento")
	return /** @type {LocalizedString} */ ("Max Lines Per Event")
});